import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function Register() {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) {
      toast.error("Password must be at least 6 characters");
      return;
    }
    setSubmitting(true);
    try {
      await register(email.trim(), password, name.trim());
      toast.success("Welcome to TAMORÉ");
      navigate("/account");
    } catch (err) {
      toast.error(formatApiError(err));
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="grid grid-cols-1 md:grid-cols-2 min-h-[80vh]" data-testid="register-page">
      <div className="hidden md:block overflow-hidden" style={{ background: "var(--line-soft)" }}>
        <img
          src="https://images.pexels.com/photos/29090944/pexels-photo-29090944.jpeg"
          alt="Tamoré"
          className="object-cover w-full h-full"
        />
      </div>
      <div className="flex items-center px-8 sm:px-16 py-20">
        <form className="w-full max-w-sm fade-up" onSubmit={submit}>
          <p className="tracking-overline text-[11px] uppercase opacity-60">Membership</p>
          <h1 className="font-display text-5xl mt-4">Create<br /><span className="italic">account.</span></h1>
          <p className="mt-4 opacity-70 text-sm">Order history, saved sizing and access to atelier previews.</p>

          <div className="space-y-6 mt-12">
            <div>
              <label className="tm-label">Full Name</label>
              <input
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
                className="tm-input"
                data-testid="register-name-input"
              />
            </div>
            <div>
              <label className="tm-label">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="tm-input"
                data-testid="register-email-input"
              />
            </div>
            <div>
              <label className="tm-label">Password</label>
              <input
                type="password"
                required
                minLength={6}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="tm-input"
                data-testid="register-password-input"
              />
            </div>
          </div>

          <button
            type="submit"
            disabled={submitting}
            className="btn-primary w-full mt-10"
            data-testid="register-submit-button"
          >
            {submitting ? "Creating..." : "Create Account"}
          </button>

          <p className="mt-8 text-sm opacity-70 text-center">
            Already a member?{" "}
            <Link to="/login" className="underline underline-offset-4" data-testid="register-login-link">
              Sign in
            </Link>
          </p>
        </form>
      </div>
    </main>
  );
}
